import { Injectable } from "@angular/core";
import { DialogLike, DialogService } from "@obg/mat.ui.core";
import { map } from "rxjs/operators";

import { LATEST_TC_DIALOG_ID } from "./latest-terms-and-conditions.const";
import { LatestTermsAndConditionsContainer } from "./latest-terms-and-conditions.container";

const LATEST_TC_DIALOG: DialogLike<LatestTermsAndConditionsContainer> = {
	dialogId: LATEST_TC_DIALOG_ID,
	dialogComponentType: LatestTermsAndConditionsContainer,
	onClose$: (c) => c.close,
	onBusy$: (c) => c.busy.pipe(map((isBusy) => ({ isBusy }))),
};

@Injectable({
	providedIn: "root",
})
export class LatestTermsAndConditionsDialogService {
	constructor(private dialogService: DialogService) {}

	open(isDesktop: boolean) {
		return () => {
			this.dialogService.openComponent(LATEST_TC_DIALOG, {
				panelClass: "obg-m-latest-terms-and-conditions-dialog",
				data: {
					hideClose: true,
					hideFooter: true,
					navbar: !isDesktop,
					title: "terms-and-conditions.updated-title",
					navbarOptions: {
						hideBackButton: true,
					},
				},
				width: "initial",
				height: "initial",
				autoFocus: false,
				disableClose: true,
			});
		};
	}
}
